import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function BetaBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleClick = () => {
    window.open("https://www.realtyblocks.com", "_blank");
  };

  return (
    <div
      onClick={handleClick}
      className={`w-full py-2 px-4 text-center cursor-pointer hover:opacity-90 transition-all duration-300 fixed top-0 left-0 right-0 z-[60] ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
      style={{ backgroundColor: '#D97706' }}
    >
      <p className="text-sm font-medium text-white">
        {t("beta.message")} <span className="underline">{t("beta.cta")}</span>
      </p>
    </div>
  );
}
